export default function PullQuote() {
  return (
    <section
      data-testid="pull-quote-section"
      className="relative bg-charcoal text-sand py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 grain-overlay opacity-30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
          {/* Left: quote */}
          <div className="md:col-span-7">
            <div className="text-[11px] uppercase tracking-[0.3em] text-ochre/85 mb-8">
              A Question Worth Holding
            </div>
            <blockquote
              data-testid="pull-quote-text"
              className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.1] tracking-tight text-sand"
            >
              If freight stopped for
              <span className="italic text-ochre"> two weeks</span>,
              <br className="hidden md:block" />
              what would remote communities eat?
            </blockquote>

            <p className="mt-10 max-w-xl text-base md:text-lg leading-relaxed text-sand/75">
              Food security is not simply a supply chain issue. It is an issue
              of access, resilience, and community capability — and it begins
              long before the shelves are empty.
            </p>
          </div>

          {/* Right: image */}
          <div className="md:col-span-5">
            <div className="relative">
              <img
                src="https://customer-assets.emergentagent.com/job_country-gardens/artifacts/5xbnhhxv_emptyshevles.jpg"
                alt="Empty supermarket shelves — the visible end of a fragile supply chain"
                data-testid="pull-quote-image"
                className="w-full aspect-[4/5] object-cover"
              />
              <div className="absolute -bottom-5 -left-5 hidden md:block bg-rust text-sand px-5 py-3 text-[11px] uppercase tracking-[0.25em]">
                When the trucks don't come
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
